module.exports = __webpack_public_path__ + "static/img/3_1_1_2.662af282.jpg";